// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabLink_tab__Kv3D1 {
  background-color: #f6f6f6;
  padding: 0.5rem;
  box-shadow: inset 0 0 0 1px #E3E3E3;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #333333;
  cursor: pointer;
  flex-shrink: 0;
}
.TabLink_tab__Kv3D1:hover {
  color: black;
}
.TabLink_tab__Kv3D1[data-selected=true] {
  background-color: white;
  box-shadow: inset 0 4px #BCCF00, inset 1px 0 #E3E3E3, inset -1px 0 #E3E3E3;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/TabsNavigation/TabLink.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,eAAA;EACA,mCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,uBAAA;EACA,0EACE;AADN","sourcesContent":[".tab {\n  background-color: #f6f6f6;\n  padding: 0.5rem;\n  box-shadow: inset 0 0 0 1px #E3E3E3;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #333333;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.tab:hover {\n  color: black;\n}\n.tab[data-selected=true] {\n  background-color: white;\n  box-shadow: inset 0 4px #BCCF00, inset 1px 0 #E3E3E3, inset -1px 0 #E3E3E3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab": `TabLink_tab__Kv3D1`
};
export default ___CSS_LOADER_EXPORT___;
